import { ActionType, createReducer } from 'typesafe-actions';
import { combineReducers } from 'redux';
import { LoyaltyRewardsReducer } from '../types/reducer';
import { clearLoyaltyRewardsAction, FETCH_LOYALTY_REWARDS } from '../actions';

export type FetchLoyaltyRewardsReducerActions1 =
  | ActionType<typeof FETCH_LOYALTY_REWARDS.success>
  | ActionType<typeof clearLoyaltyRewardsAction>;
export const loyaltyRewards = createReducer<
  LoyaltyRewardsReducer.ILoyaltyReward | null,
  FetchLoyaltyRewardsReducerActions1
>(null)
  .handleAction(FETCH_LOYALTY_REWARDS.success, (_, { payload }) => payload)
  .handleAction(clearLoyaltyRewardsAction, () => null);

export type FetchLoyaltyRewardsReducerActions =
  | ActionType<typeof FETCH_LOYALTY_REWARDS.request>
  | ActionType<typeof FETCH_LOYALTY_REWARDS.success>
  | ActionType<typeof FETCH_LOYALTY_REWARDS.failure>
  | ActionType<typeof FETCH_LOYALTY_REWARDS.cancel>;
export const loyaltyRewardsLoading = createReducer<boolean, FetchLoyaltyRewardsReducerActions>(false)
  .handleAction(FETCH_LOYALTY_REWARDS.request, () => true)
  .handleAction(
    [FETCH_LOYALTY_REWARDS.success, FETCH_LOYALTY_REWARDS.failure, FETCH_LOYALTY_REWARDS.cancel],
    () => false,
  );

export type FetchLoyaltyRewardsErrorReducerActions =
  | ActionType<typeof FETCH_LOYALTY_REWARDS.request>
  | ActionType<typeof FETCH_LOYALTY_REWARDS.failure>;
export const loyaltyRewardsError = createReducer<string | null, FetchLoyaltyRewardsErrorReducerActions>(null)
  .handleAction(FETCH_LOYALTY_REWARDS.request, () => null)
  .handleAction(FETCH_LOYALTY_REWARDS.failure, (_, { payload }) => payload.message);

export const loyaltyRewardsReducer = combineReducers({
  data: loyaltyRewards,
  loyaltyRewardsError,
  loyaltyRewardsLoading,
});
